module.exports = __webpack_public_path__ + "static/img/star_person_service.b154ddc2.png";